// Upstream: shadcn-ui/ui apps/v4/registry/new-york-v4/ui/badge.tsx + cosscom/coss apps/origin/registry/default/components/comp-419.tsx (status dot) — MIT.

import type { ComponentProps } from "react";
import { badgeClass, statusDotClass, type BadgeTone } from "@ahcut/ui/recipes";
import { cn } from "@/lib/cn";
import type { PillTone } from "@/lib/format";

/** The dashboard's status vocabulary (lib/format PillTone) → recipe tones. */
const TONE: Record<PillTone, BadgeTone> = {
  neutral: "neutral",
  pro: "accent",
  signal: "accent",
  ok: "ok",
  warn: "warn",
  crit: "danger",
};

export function badgeTone(tone: PillTone): BadgeTone {
  return TONE[tone];
}

export interface BadgeProps extends ComponentProps<"span"> {
  tone?: PillTone;
  /** Status dot before the label (never instead of it — DESIGN.md §3). */
  dot?: boolean;
}

export function Badge({ tone = "neutral", dot = false, className, children, ...rest }: BadgeProps) {
  const recipeTone = TONE[tone];
  return (
    <span data-slot="badge" className={cn(badgeClass(recipeTone), className)} {...rest}>
      {dot && <span aria-hidden="true" className={statusDotClass(recipeTone)} />}
      {children}
    </span>
  );
}
